/* eslint-disable camelcase */
export default {
  you_are_logged_in: 'Вы вошли в систему!',
  password_changed: 'Пароль изменен!',
  forgot_password: "Забыли пароль?",
  login_button: "Войти",
  unknown_error: "Произошла неизвестная ошибка при попытке входа в систему",
};
